import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { type Dispatch } from 'redux';

import { hide } from '../reducers/request-failed/reducer';
import { type IRequestFailedState } from '../reducers/request-failed/types';

export const REQUEST_FAILED_BANNER_TIMEOUT_MS = 8000;

function RequestFailedBanner({
  dispatch,
  RequestFailed,
}: {
  dispatch: Dispatch;
  RequestFailed: IRequestFailedState;
}): React.JSX.Element | null {
  const { t } = useTranslation();

  useEffect((): (() => void) | undefined => {
    if (!RequestFailed.visible) {
      return undefined;
    }

    const timer = setTimeout((): void => {
      dispatch(hide());
    }, REQUEST_FAILED_BANNER_TIMEOUT_MS);

    return (): void => clearTimeout(timer);
  }, [dispatch, RequestFailed.visible]);

  if (!RequestFailed.visible) {
    return null;
  }

  return (
    <div className="request-failed" role="alert">
      <p className="request-failed__text">{t('common.requestFailed')}</p>
      <button
        type="button"
        className="request-failed__close"
        aria-label={t('common.close')}
        onClick={(): void => {
          dispatch(hide());
        }}
      >
        ×
      </button>
    </div>
  );
}

const mapStateToProps = ({
  RequestFailed,
}: {
  RequestFailed: IRequestFailedState;
}): { RequestFailed: IRequestFailedState } => ({
  RequestFailed,
});

export default connect(mapStateToProps)(RequestFailedBanner);
